/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import Icon from '../helpers/svg-icon';

const PlusIcon = ({ fillColor = '#fff', width = 20, height = 20 }) => (
  <Icon height={height} width={width} viewBox="0 0 20 20">
    <path
      d="m8.261 0v8.261h-8.261v3.479h8.261v8.26h3.479v-8.26h8.26v-3.479h-8.26v-8.261z"
      fill={fillColor}
    />
  </Icon>
);

const InfoIcon = ({ fillColor = '#EAC80C', width = 18, height = 18 }) => (
  <Icon height={height} width={width} viewBox="0 0 18.8 18.8">
    <path
      d="m13.4 4a9.4 9.4 0 1 0 9.4 9.4 9.4 9.4 0 0 0 -9.4-9.4zm-.992 4.966h1.992v1.712h-1.993zm3.006 8.865h-4.03v-1.763h1.038v-2.555h-1.038v-1.762h3.016v4.318h1.013z"
      fill={fillColor}
      transform="translate(-4 -4)"
    />
  </Icon>
);

const CircleTick = ({
  fillColorMain,
  fillColorSecondary,
  v2ProductDetail,
  width = 20,
  height = 20,
}) => (
  <CircleTickIcon
    viewBox="0 0 28 28"
    className={v2ProductDetail && 'mr-05'}
    width={width}
    height={height}>
    <path
      d="M26 14c0 6.629-5.371 12-12 12S2 20.629 2 14 7.371 2 14 2s12 5.371 12 12zm0 0"
      fill={fillColorMain}
    />
    <path
      d="M20.3 10.5L18.8 9l-.3.3-6.102 6.098-3.296-3.296-.301.296-1.102
      1.204-.3.398.3.3 4.403 4.4.296.3.301-.3 7.602-7.598.3-.301zm0 0"
      fill={fillColorSecondary}
    />
  </CircleTickIcon>
);

const SearchIcon = ({ fillColor = '#B1B1B1', width = 15, height = 15 }) => (
  <Icon height={height} width={width} viewBox="0 0 15 15.188">
    <path
      d="M15,13.2,11.391,9.352A6.251,6.251,0,0,0,12.3,6.141a6.152,6.152,0,0,0-12.3,0,6.138,6.138,0,0,0,9.4,5.2l3.609,3.844ZM2.109,6.141a4.031,4.031,0,1,1,4.031,4.031A4.031,4.031,0,0,1,2.109,6.141Z"
      fill={fillColor}
    />
  </Icon>
);

const ChevronIcon = ({ fillColor = '#4c4c4c', width = 14, height = 9 }) => (
  <Icon height={height} width={width} viewBox="0 0 9.586 5.615">
    <path
      d="M519.655,364.084l-.823-.823-3.97,3.97-3.97-3.97-.823.823,4.793,4.793Z"
      transform="translate(-510.069 -363.262)"
      fill={fillColor}
    />
  </Icon>
);

const CircleXmark = ({
  circleFillColor = '#4B4B4B',
  xmarkFillColor = '#ffffff',
  width = 38,
  height = 38,
}) => (
  <Icon width={width} height={height} viewBox="0 0 20 20">
    <g transform="translate(-800 -1691)">
      <circle
        cx="10"
        cy="10"
        r="10"
        transform="translate(800 1691)"
        fill={circleFillColor}
      />
      <g transform="translate(809.928 1693.858) rotate(45)">
        <rect
          id="Rectangle_13980"
          data-name="Rectangle 13980"
          width="2"
          height="10"
          transform="translate(4)"
          fill={xmarkFillColor}
        />
        <rect
          width="2"
          height="10"
          transform="translate(10 4) rotate(90)"
          fill={xmarkFillColor}
        />
      </g>
    </g>
  </Icon>
);

const Arrow = ({ fillColor, isHidden, width = 9, height = 15 }) => (
  <ArrowChange
    transform={isHidden ? 'rotate(90)' : 'rotate(-90)'}
    width={width}
    height={height}>
    <path
      d="M0 11.829l4.96-4.96L0 1.909 1.913-.004l6.872 6.872-6.872 6.877z"
      fill={fillColor}
    />
  </ArrowChange>
);

const CircleTickIcon = styled(Icon)`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`;

const ArrowChange = styled(Icon)`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  margin-left: 8px;
`;

const StoreIcon = ({ width = 30, height = 20, fillColour }) => (
  <Icon width={width} height={height} viewBox="0 0 40 40">
    <path
      fill={fillColour}
      d="M3.4,11v3.1h2.4v16.9h28.3V14.1h2.5V11C19.9,6.7,3.4,11,3.4,11z M19.6,29.9h-4.7v-9.3h4.7V29.9z M25.1,29.9
  h-4.7v-9.3h4.7L25.1,29.9z"
    />
  </Icon>
);

const PhoneIcon = ({ width = 18, height = 18, fillColour }) => (
  <Icon width={width} height={height} viewBox="0 0 53 74.71">
    <path
      fill={fillColour}
      d="M8.44,46.48C6.15,42.16,1.72,28.1,1.72,28.1S-2.59,6.6,15,.42l8.41,2.26,3.12,15.67-10.9,6.76S13.9,30.07,19,42h0c5.89,11.63,10.79,13.49,10.79,13.49l12.18-4,10,12.43-3.65,7.91c-16,9.53-29.75-7.55-29.75-7.55S11,51.37,8.44,46.48Z"
    />
  </Icon>
);

const EmailIcon = ({ width = 13, height = 8, fillColour }) => (
  <Icon width={width} height={height} viewBox="0 0 69.56 52.38">
    <polygon
      fill={fillColour}
      points="68.46 0.69 1.1 0.69 34.78 32.33 68.46 0.69"
    />
    <polygon
      fill={fillColour}
      points="39.57 37.43 34.78 41.93 29.98 37.43 1.1 10.29 1.1 51.38 68.46 51.38 68.46 10.29 39.57 37.43"
    />
  </Icon>
);

const CloseXmark = ({
  width = 38,
  height = 38,
  backgroundFllColour = '#ffffff',
  mainFillColour = '#191919',
  strokeColour = '#191919',
}) => (
  <Icon width={width} height={height} viewBox="0 0 38 38">
    <g transform="translate(-1162 -272)">
      <circle
        cx="19"
        cy="19"
        r="19"
        transform="translate(1162 272)"
        fill={backgroundFllColour}
      />
      <path
        d="M13.6,10.4V0H10.4V10.4H0v3.2H10.4V24h3.2V13.6H24V10.4Z"
        transform="translate(1181 274.48) rotate(45)"
        fill={mainFillColour}
        stroke={strokeColour}
        strokeWidth="1"
      />
    </g>
  </Icon>
);

/* eslint-enable max-len */
export {
  PlusIcon,
  InfoIcon,
  SearchIcon,
  ChevronIcon,
  StoreIcon,
  PhoneIcon,
  EmailIcon,
  CloseXmark,
  CircleTick,
  Arrow,
  CircleXmark,
};
